import './GroupedBarVisualization.scss';

export { uiSchema, getSchema } from '../../schemas/GroupedBarVisualizationSchema';
export { default } from './GroupedBarVisualization';
